<template>
  <div class="wrapper daftarkan-masjid">
    <div class="donation-detail">
      <div
        class="main-content bg-white"
        style="padding: 15px; padding-bottom: 30px;"
      >
        <img src="/img/terimakasih.png" alt="" class="terimakasih mt-5" />
        <p class="notice-text mt-3">
          Terima Kasih telah mendaftarkan user RELAWAN, <br />
          Data yang anda daftarkan akan kami review terlebih dahulu.
        </p>
        <div class="row">
          <div class="col-6">
            <a
              href="javascript:void(0)"
              class="btn btn-main mt-3"
              @click="daftarkanBaru()"
              ><i class="fa fa-plus"></i> Buat Baru</a
            >
          </div>
          <div class="col-6">
            <a
              href="javascript:void(0)"
              class="btn btn-main mt-3"
              @click="daftarUser()"
              ><i class="fa fa-home"></i> Kembali</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    daftarkanBaru() {
      const ref_code = this.$route.params.ref_code;

      this.$router.push({
        name: "akusisi-user-relawan",
        params: {
          ref_code,
        },
      });
    },
    daftarUser() {
      const ref_code = this.$route.params.ref_code;

      this.$router.push({
        name: "akusisi-user-report-relawan",
        params: {
          ref_code,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  box-sizing: border-box;
  top: 0px;
  padding: 0px;
  min-height: calc(100vh - 0px);
}

.terimakasih {
  display: block;
  position: relative;
  margin: 0 auto;
  height: 200px;
}

.notice-text {
  text-align: center;
}

.btn-main {
  display: block;
  position: relative;
  margin: 0 auto;
}
</style>
